<div class="h-100">
      <router-outlet></router-outlet>
</div>
